import jsPDF from 'jspdf';
import robotoBase64 from './roboto-font';
import robotoBoldBase64 from './roboto-bold-font';
import caveatBase64 from './caveat-font';

function setupFonts(doc) {
  doc.addFileToVFS('DejaVuSans.ttf', robotoBase64);
  doc.addFont('DejaVuSans.ttf', 'DejaVu', 'normal');
  doc.addFileToVFS('DejaVuSans-Bold.ttf', robotoBoldBase64);
  doc.addFont('DejaVuSans-Bold.ttf', 'DejaVu', 'bold');
  doc.addFileToVFS('Caveat.ttf', caveatBase64);
  doc.addFont('Caveat.ttf', 'Caveat', 'normal');
}

export function generateCertificatePDF(certData) {
  var doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a5',
  });

  setupFonts(doc);

  var width = doc.internal.pageSize.getWidth();
  var height = doc.internal.pageSize.getHeight();
  var centerX = width / 2;

  // Soft background
  doc.setFillColor(255, 253, 254);
  doc.rect(0, 0, width, height, 'F');

  // Single elegant thin border
  doc.setDrawColor(212, 137, 158);
  doc.setLineWidth(0.4);
  doc.rect(10, 10, width - 20, height - 20);

  var y = 30;

  // Title - ALENA.BOTOX
  doc.setFont('DejaVu', 'bold');
  doc.setFontSize(26);
  doc.setTextColor(60, 40, 50);
  doc.text('A L E N A . B O T O X', centerX, y, { align: 'center' });
  y += 10;

  // Subtitle
  doc.setFont('DejaVu', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(150, 120, 135);
  doc.text('\u041B \u0406 \u041A \u0410 \u0420   \u041A \u041E \u0421 \u041C \u0415 \u0422 \u041E \u041B \u041E \u0413', centerX, y, { align: 'center' });
  y += 5.5;
  doc.text('\u0410 \u0412 \u0422 \u041E \u0420  \u0422 \u0412 \u041E \u0404 \u0407  \u0412 \u0418 \u0420 \u0410 \u0417 \u041D \u041E \u0407  \u041A \u0420 \u0410 \u0421 \u0418', centerX, y, { align: 'center' });
  y += 12;

  // Decorative line with diamond
  doc.setDrawColor(212, 137, 158);
  doc.setLineWidth(0.3);
  doc.line(25, y, centerX - 5, y);
  doc.line(centerX + 5, y, width - 25, y);
  doc.setFillColor(212, 137, 158);
  doc.triangle(centerX, y - 2, centerX + 2, y, centerX, y + 2, 'F');
  doc.triangle(centerX, y - 2, centerX - 2, y, centerX, y + 2, 'F');
  y += 14;

  // Certificate title
  doc.setFont('DejaVu', 'bold');
  doc.setFontSize(20);
  doc.setTextColor(60, 40, 50);
  doc.text('\u0421 \u0415 \u0420 \u0422 \u0418 \u0424 \u0406 \u041A \u0410 \u0422', centerX, y, { align: 'center' });
  y += 9;

  doc.setFont('DejaVu', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(140, 120, 130);
  doc.text('\u041D \u0410   \u041F \u041E \u0421 \u041B \u0423 \u0413 \u0418   \u041A \u041E \u0421 \u041C \u0415 \u0422 \u041E \u041B \u041E \u0413 \u0410', centerX, y, { align: 'center' });
  y += 16;

  // Client name - handwritten style
  if (certData.clientName) {
    doc.setFont('DejaVu', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(170, 150, 160);
    doc.text('\u0414\u043B\u044F:', centerX, y, { align: 'center' });
    y += 10;

    doc.setFont('Caveat', 'normal');
    doc.setFontSize(24);
    doc.setTextColor(60, 40, 50);
    doc.text(certData.clientName, centerX, y, { align: 'center' });
    y += 5;

    // Elegant underline
    doc.setDrawColor(212, 137, 158);
    doc.setLineWidth(0.3);
    doc.line(35, y, width - 35, y);
    y += 12;
  }

  // Value - handwritten style
  var label = certData.type === 'amount' ? '\u0421\u0443\u043C\u0430:' : '\u041F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430:';
  var displayValue = certData.type === 'amount'
    ? certData.value + ' \u0433\u0440\u043D'
    : certData.value;

  doc.setFont('DejaVu', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(170, 150, 160);
  doc.text(label, centerX, y, { align: 'center' });
  y += 10;

  doc.setFont('Caveat', 'normal');
  doc.setFontSize(22);
  doc.setTextColor(60, 40, 50);
  doc.text(displayValue, centerX, y, { align: 'center' });
  y += 5;

  doc.setDrawColor(212, 137, 158);
  doc.setLineWidth(0.3);
  doc.line(35, y, width - 35, y);
  y += 14;

  // Validity notice
  doc.setFont('DejaVu', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(160, 140, 150);
  doc.text('\u0421\u0415\u0420\u0422\u0418\u0424\u0406\u041A\u0410\u0422 \u041C\u041E\u0416\u041D\u0410 \u0412\u0418\u041A\u041E\u0420\u0418\u0421\u0422\u0410\u0422\u0418', centerX, y, { align: 'center' });
  y += 5;
  doc.text('\u041F\u0420\u041E\u0422\u042F\u0413\u041E\u041C 6 \u041C\u0406\u0421\u042F\u0426\u0406\u0412', centerX, y, { align: 'center' });
  y += 10;

  // Dates - centered
  doc.setFont('DejaVu', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(160, 140, 150);
  doc.text('\u0414\u0430\u0442\u0430 \u0432\u0438\u0434\u0430\u0447\u0456: ' + certData.issueDate + '          \u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0434\u043E: ' + certData.expiryDate, centerX, y, { align: 'center' });
  y += 10;

  // Certificate number
  doc.setFont('DejaVu', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(212, 137, 158);
  doc.text('\u2116 ' + certData.number, centerX, y, { align: 'center' });

  // Footer - positioned from bottom with enough space
  var footerY = height - 16;

  // Decorative line with diamond before footer
  var fLineY = footerY - 6;
  doc.setDrawColor(212, 137, 158);
  doc.setLineWidth(0.3);
  doc.line(30, fLineY, centerX - 3, fLineY);
  doc.line(centerX + 3, fLineY, width - 30, fLineY);
  doc.setFillColor(212, 137, 158);
  doc.triangle(centerX, fLineY - 1.5, centerX + 1.5, fLineY, centerX, fLineY + 1.5, 'F');
  doc.triangle(centerX, fLineY - 1.5, centerX - 1.5, fLineY, centerX, fLineY + 1.5, 'F');

  doc.setFont('DejaVu', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(140, 120, 130);

  // Footer with clickable links
  var phoneText = '+38063 738 5557';
  var separator = '   |   ';
  var instaText = '@ALENA.BOTOX';

  var fullText = phoneText + separator + instaText;
  var fullWidth = doc.getTextWidth(fullText);
  var startX = centerX - fullWidth / 2;

  // Phone
  doc.text(phoneText, startX, footerY);
  var phoneWidth = doc.getTextWidth(phoneText);
  doc.link(startX, footerY - 3, phoneWidth, 5, { url: 'tel:+380637385557' });

  // Separator
  doc.text(separator, startX + phoneWidth, footerY);
  var sepWidth = doc.getTextWidth(separator);

  // Instagram
  var instaX = startX + phoneWidth + sepWidth;
  doc.text(instaText, instaX, footerY);
  var instaWidth = doc.getTextWidth(instaText);
  doc.link(instaX, footerY - 3, instaWidth, 5, { url: 'https://www.instagram.com/alena.botox/' });

  // Telegram link below
  footerY += 5;
  doc.setTextColor(212, 137, 158);
  var tgText = 'Telegram';
  doc.text(tgText, centerX, footerY, { align: 'center' });
  var tgWidth = doc.getTextWidth(tgText);
  doc.link(centerX - tgWidth / 2, footerY - 3, tgWidth, 5, { url: 'https://t.me/alonabotox' });

  // Return blob for sharing
  var blob = doc.output('blob');
  var fileName = 'certificate-' + certData.number + '.pdf';
  var file = new File([blob], fileName, { type: 'application/pdf' });
  return { blob: blob, file: file, fileName: fileName, doc: doc };
}
